import { Injectable } from '@angular/core';
import { Storage, StorageReference, uploadBytes, UploadResult, ref, getDownloadURL } from '@angular/fire/storage';

type FilePredicate = string | StorageReference;

@Injectable({ providedIn: 'root' })
export class StorageService {

  constructor(private storage: Storage) {}

  /** Get References */
  fileRef(reference: FilePredicate) {
    return typeof reference === 'string' ? ref(this.storage, reference) : reference;
  }

  /** Get Download URL */
  getURL(ref: FilePredicate): Promise<string> {
    return getDownloadURL(this.fileRef(ref));
  }

  /** Upload Files */
  upload(ref: FilePredicate, file: File): Promise<UploadResult> {
    return uploadBytes(this.fileRef(ref), file);
  }
}
